import { StatesModule, Transition } from '@uirouter/angular';
import { ApplicationSettingsType } from '@fi-shared/types/application-settings-type';
import { AccessRightType } from '@fi-shared/types/access-right-type';
import { StateAccessCheckService } from '@fi-shared/fi-shared-services/state-access-check.service';
import { FiAbstractStateComponent } from '@fi-shared/fi-state-proxy/fi-abstract-state.component';
import { DataFieldGroupEditComponent } from '@fi-app/data-field/data-field-group-edit/data-field-group-edit.component';
import { PageTitleService } from '@fi-app/utilities/fi-services/page-title.service';
import { ObjectTypes } from '@fi-shared/types/object-type';
import { FiStateService } from '@fi-shared/fi-state-proxy/fi-state.proxy.service';
import { DataFieldGroupModel } from '@fi-app/data-field/data-field-group-model';
import { DataFieldService } from '@fi-app/data-field/data-field.service';
import { FiStateNames } from '@fi-shared/fi-state-proxy/fi-state-names';

const DataFieldState = {
    name: 'DataField',
    url: '/DataField',
    abstract: true,
    parent: FiStateNames.GlobalSettings,
    component: FiAbstractStateComponent,
};

export function DataFieldEditDataFieldObjectType(stateService: FiStateService, transition: Transition) {
    return stateService.getParams(transition).ObjectType;
}
export function DataFieldEditDataFieldGroup(objectType: ObjectTypes, fiDataFieldService: DataFieldService) {
    return fiDataFieldService.getDataFieldGroup(objectType);
}
export function DataFieldEditPageTitle(ccmPageTitle: PageTitleService, dataFieldGroup: DataFieldGroupModel) {
    ccmPageTitle.setTitleByItem(dataFieldGroup);
}
export function DataFieldEditDataFieldByIdObjectType(
    stateService: FiStateService,
    transition: Transition,
    fiDataFieldService: DataFieldService,
) {
    return fiDataFieldService.getDataFieldGroupObjectTypeById(stateService.getParams(transition).Id);
}

const DataFieldEditState = {
    name: FiStateNames.OtherSettings.DataField,
    url: '/DataField/{ObjectType:[0-9]+}/Edit',
    views: {
        '@': {
            component: DataFieldGroupEditComponent,
        },
    },
    resolve: {
        objectType: [FiStateService, Transition, DataFieldEditDataFieldObjectType],
        dataFieldGroup: ['objectType', DataFieldService, DataFieldEditDataFieldGroup],
        pageTitle: [PageTitleService, 'dataFieldGroup', DataFieldEditPageTitle],
    },
};

const DataFieldEditByIdState = {
    name: 'DataField.EditById',
    url: '/{Id:[0-9]+}/Edit',
    views: {
        '@': {
            component: DataFieldGroupEditComponent,
        },
    },
    resolve: {
        objectType: [FiStateService, Transition, DataFieldService, DataFieldEditDataFieldByIdObjectType],
        dataFieldGroup: ['objectType', DataFieldService, DataFieldEditDataFieldGroup],
        pageTitle: [PageTitleService, 'dataFieldGroup', DataFieldEditPageTitle],
    },
};

export const DataFieldStates: StatesModule = {
    states: [DataFieldState, DataFieldEditState, DataFieldEditByIdState],
};

export function registerDataFieldStateRules(stateAccessCheckService: StateAccessCheckService) {
    stateAccessCheckService.registerStateRules([FiStateNames.OtherSettings.DataField], {
        SettingType: [ApplicationSettingsType.CoreGlobal],
        AccessType: AccessRightType.Admin,
    });
}
